<template>
  <div>
    <v-dialog v-model="value" persistent>
      <v-card>
        <v-layout>
          <v-flex class="pa-2 form-control" style="max-width: 300px">
            <multiselect
              v-model="papersize"
              :options="papersizeOptions"
              :allow-empty="false"
              :searchable="false"
              selectLabel
              selectedLabel
              deselect-label
            ></multiselect>
            <!-- <select v-model="papersize" style="display: inline-block">
              <option v-for="option in papersizeOptions" :key="option" :value="option">
                {{ option }}
              </option>
            </select> -->
          </v-flex>
          <v-flex>
            <v-btn color="primary" class="ma-2" :href="pdflink" target="_blank">
              <v-icon class="mr-1">download</v-icon>Download
            </v-btn>
          </v-flex>
          <v-flex shrink class="text-xs-right">
            <v-btn small fab flat @click="closePreview"><v-icon>close</v-icon></v-btn>
          </v-flex>
        </v-layout>
        <v-divider></v-divider>
        <v-card-text>
          <!-- <div class="text-xs-center my-4" v-show="!showPreview">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
          </div>

          <div v-show="showPreview"> -->
          <div style="border: 1px solid #eee">
            <embed
              @load="onPreviewLoad"
              :key="papersize"
              :src="pdflink"
              style="width: 100%; height: 500px; margin: 0px; padding: 0px;"
            />
          </div>
          <!-- </div> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import config from '@/config'
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'purchase_id'],
  data() {
    return {
      showPreview: false,
      papersizeOptions: [
        'A4',
        'A5',
        'A6',
        'receipt',
        'letter',
        'letter4x6',
        'sticker',
        'sticker4x6'
      ],
      papersize: 'A4'
    }
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    pdflink() {
      return `${config.serverUrl}shippopaddresslabel?pageid=${
        this.selectedBot.pageid
      }&purchase_id=${this.purchase_id}&size=${this.papersize}`
    }
  },
  methods: {
    onPreviewLoad() {
      this.showPreview = true
    },
    closePreview() {
      this.$emit('closePreview')
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PreviewShippopCover.vue